import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import * as styles from './FeatureStatusIndicator.scss';
import { FeatureStatusMap } from '../../store/workspaces/types';

interface OwnProps {
    featureId: string;
}

interface Props extends OwnProps {
    status: string;
}

interface WithFeatureStatus {
    workspaces: {
        featureStatus: FeatureStatusMap;
    };
}

function FeatureStatusIndicator(props: Props): ReactElement {
    const { status } = props;

    return (
        <div
            className={`${styles.featureStatusIndicator} ${status || ''}`}
        />
    );
}

const mapStateToProps = (state: WithFeatureStatus, ownProps: OwnProps): Props => ({
    status: state.workspaces.featureStatus[ownProps.featureId],
    ...ownProps,
});

export default connect<Props, void, OwnProps>(mapStateToProps, null)(FeatureStatusIndicator);
